export type HardwareDocumentFormValue =
  | null
  | { url: string; title: string }
  | { public_file_id: number; title?: string; url?: string }

export type HardwareDocumentApiPayload = null | { public_file_id: number }

type LinkedPublicFile = { url?: string | null; title?: string | null }

const filenameFromUrl = (url: string) => url.split('/').pop()?.split('?')[0] || url

const isLinkedPublicFile = (value: unknown): value is LinkedPublicFile =>
  typeof value === 'object' && value !== null && 'url' in value

/** Map API hardware_document field values into structured form state. */
export const formatHardwareDocumentFromApi = (value: unknown): HardwareDocumentFormValue => {
  if (value == null) {
    return null
  }

  if (typeof value === 'object' && 'public_file_id' in value && value.public_file_id != null) {
    const linked = value as { public_file_id: number; title?: string; url?: string }
    return {
      public_file_id: linked.public_file_id,
      title: linked.title,
      url: linked.url,
    }
  }

  if (isLinkedPublicFile(value)) {
    if (!value.url) {
      return null
    }
    return {
      url: value.url,
      title: value.title || filenameFromUrl(value.url),
    }
  }

  return null
}

/** Serialize one field for the component API. `undefined` means leave unchanged (omit from PATCH). */
export const serializeHardwareDocumentFieldForApi = (
  value: HardwareDocumentFormValue
): HardwareDocumentApiPayload | undefined => {
  if (value == null) {
    return null
  }
  if ('public_file_id' in value && value.public_file_id != null) {
    return { public_file_id: value.public_file_id }
  }
  if ('url' in value) {
    return undefined
  }
  return undefined
}
